import React from 'react';
import { JsonForms } from '@jsonforms/react';
import {
  materialCells,
  materialRenderers
} from '@jsonforms/material-renderers';
import { Modal, Portal, Card, CardContent, CardHeader, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HorizontalResponsiveRenderer, { HorizontalResponsiveTester } from '../../../components/json-forms/layouts/HorizontalResponsive';
import TextRenderer, { TextTester } from '../../../components/json-forms/layouts/Text';
import { schema, uischema } from '../../employee/applications/applicationForm/tabs/PreviewQuestionnaire/schemas';
import { formatDateTime } from '../../../services/functions';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';
import { useStaff } from '../../../pages/Staff';

dayjs.locale('pl');


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function PreviewQuestionnaire({ handleClose }) {
  const { application: rowData } = useStaff();
  const [data, setData] = React.useState(rowData.questionnaire_data.data);
  const [errors, setErrors] = React.useState([]);
  const [validationMode, setValidationMode] = React.useState('ValidateAndHide');

  const translator = (key, defaultMessage) => {

    if (key.endsWith('.required')) {
      return 'To pole jest wymagane';
    }

    if (key.endsWith('.pattern') || key.endsWith('.format')) {
      return 'Niepoprawna wartość pola';
    }

    return defaultMessage;
  };

  const renderers = [
    ...materialRenderers,
    { tester: HorizontalResponsiveTester, renderer: HorizontalResponsiveRenderer },
    { tester: TextTester, renderer: TextRenderer }
  ];

  return (
    <Portal>
      <Modal open={true} onClose={handleClose}>
        <Card style={{ width: '60vw', maxHeight: '80vh', ...style, display: 'flex', flexDirection: 'column' }}>
          <CardHeader title={`Wypełniony kwestionariusz (${formatDateTime(rowData.questionnaire_data.createdAt)}) - WERSJA TYLKO DO PODGLĄDU`} action={<IconButton onClick={handleClose}><CloseIcon /></IconButton>}/>
          <CardContent style={{ overflow: 'auto', flex: 1 }}>
            <JsonForms
              i18n={{ locale: 'pl', translate: translator }}
              schema={schema}
              uischema={uischema}
              data={data}
              renderers={renderers}
              cells={materialCells}
              onChange={({ errors, data: newData }) => {
                setData(newData);
                setErrors(errors);
              }}
              validationMode={validationMode}
            />
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
